import { INBOARD, MODIFIED_V, PWC, SEMI_V, TRI_HULL, V } from 'constants/boatApplication';
import { _initBoatSystems } from './BaseBoat';
import moment from 'moment';

const initState = {
  id: 'new',
  boatType: PWC,
  engineType: INBOARD,
  status: 'DRAFT',
  boatSpecifications: {},
  boatSystems: [],
  cubicCapacity: {},
  floatationCapacity: {},
  additionalFiles: [],
};

export default class Pwc {
  constructor(boat = initState) {
    this.id = boat.id || initState.id;
    this.boatType = PWC;
    this.status = boat.status || initState.status;
    this.engineType = INBOARD;
    this.plateType = boat.plateType;
    this.boatSpecifications = _initBoatSpecifications(boat.boatSpecifications || boat);
    this.boatSystems = _initBoatSystems();
    this.cubicCapacity = {};
    this.specificationsRequiredFieldsList = getSpecificationsRequiredFieldsList.call(this);
    this.personPowerCapacity = _initPersonPowerCapacity.call(this, boat.personPowerCapacity || boat);
    this.powerCapacity = null;
    this.floatationCapacity = _initFloatationCapacity(boat.floatationCapacity);
    this.additionalFiles = boat.additionalFiles ? [...boat.additionalFiles] : initState.additionalFiles;
    this.isFloatationTestReportRequired = boat.boatSpecifications ? boat.boatSpecifications.lengthFeet < 20 : boat.lengthFeet < 20;
    this.bottomContourList =
      [
        {name: 'Modified V', value: MODIFIED_V},
        {name: 'Semi V', value: SEMI_V},
        {name: 'Tri Hull', value: TRI_HULL},
        {name: 'V', value: V},
      ];
    this.engineTypesList =
      [
        INBOARD
      ];
    this.engineSubTypesList =
      [
        {name: 'Up to 6 HP.', value: 'SUB_TYPE_1'},
        {name: 'Over 6 HP. and up to 20 HP.', value: 'SUB_TYPE_2'},
        {name: 'Over 20 HP. and up to 100 HP.', value: 'SUB_TYPE_3'},
        {name: 'Over 100 HP.', value: 'SUB_TYPE_4'},
      ];
  }
}

function getSpecificationsRequiredFieldsList() {
  return [
    'name',
    'year',
    'cityAndStateForCapacityTag',
    'weightOfFinishedBoat',
    'displacement',
  ];
}

function _initBoatSpecifications(boat) {
  return {
    name: boat.name || '',
    year: boat.year || '',
    cityAndStateForCapacityTag: boat.cityAndStateForCapacityTag || '',
    weightOfFinishedBoat: boat.weightOfFinishedBoat === undefined ? '' : boat.weightOfFinishedBoat,
    displacement: boat.displacement || '',
  };
}

function _initPersonPowerCapacity(boat) {
  return {
    reqMaxNumberOfPersons: boat.reqMaxNumberOfPersons === undefined ? '' : boat.reqMaxNumberOfPersons,
    reqMaxWeight: boat.reqMaxWeight === undefined ? '' : boat.reqMaxWeight,

    appMaxWeight: boat.appMaxWeight === undefined ? '' : boat.appMaxWeight,
    appMaxNumberOfPersons: boat.appMaxNumberOfPersons === undefined ? '' : boat.appMaxNumberOfPersons,
  };
}

function _initFloatationCapacity(floatation) {
  if (floatation && floatation.length) {
    return {
      testDate: moment(floatation[0].testDate).utc(),
      files: floatation
    };
  } else {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/app/store/models/Pwc.js